<template>
    <div :class="`default main-con ${!showDesktop ? 'mobile' : ''}`">
        <div class="banner-wrapper" v-if="showDesktop">
            <div class="banner-contained con-wrapper">
                <main-header></main-header>
                <div :class="`content-con ${withAccordion ? 'with-accordion' : ''} ${wrapContent ? 'df-wrap' : ''}`">
                    <div class="con-wrapper">
                        <div v-if="title" class="page-con-header">
                            <h1>
                                <svg-star class="star"></svg-star>
                                <span>{{ title | translate }}</span>
                            </h1>
                            <svg-wave class="wave"></svg-wave>
                        </div>
                        <slot name="content"></slot>
                        <div v-if="items.length" class="content accordion-content">
                            <template v-if="isAccordionGroup">
                                <accordion-group>
                                    <li v-for="(item, index) in items" class="accordion_group" v-bind:class="{'accordion_group-active': (currentSel === index)}">
                                        <accordion-item
                                            v-if="!item.use_slot_content"
                                            :title="item.question"
                                            :content="item.answer"
                                            :index="index"
                                            :currentItem="currentSel"
                                            @onSelectItem="onSelectItem"
                                            @agBeforeEnter="agBeforeEnter"
                                            @agOnEnter="agOnEnter"
                                        ></accordion-item>
                                        <accordion-item
                                            v-else
                                            :use-slot-content="true"
                                            :custom-container="item.custom_container"
                                            :title="item.question"
                                            :index="index"
                                            :currentItem="currentSel"
                                            @onSelectItem="onSelectItem"
                                            @agBeforeEnter="agBeforeEnter"
                                            @agOnEnter="agOnEnter"
                                        >
                                            <template slot="acc-content">
                                                <slot :name="`slot-item-${index}`"></slot>
                                            </template>
                                        </accordion-item>
                                    </li>
                                </accordion-group>
                            </template>
                            <!-- // not group -->
                            <template v-else v-for="item in items">
                                <accordion-item :title="item.question" :content="item.answer"></accordion-item>
                            </template>
                            <slot name="content-after-accordion"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main-footer v-if="showDesktop"></main-footer>
        <template v-else>
            <div v-if="!noTopNav" :class="`top-nav-con ${mobile_menu_opened ? 'clear' : ''}`">
                <div class="prev-con">
                    <i v-if="!mobile_menu_opened" :class="`icon ${iconLeft}`" @click="handleBackClick"></i>
                </div>
                <div class="title-con">
                    <h4 v-if="!mobile_menu_opened">{{ title | translate }}</h4>
                </div>
                <div class="menu-con">
                    <i :class="`icon ${mobile_menu_opened ? 'icon-close' : 'icon-burger-white'}`" @click="openMobileMenu"></i>
                </div>
                <svg-wave class="wave"></svg-wave>
            </div>
            <mobile-menu 
                ref="mobile-menu" 
                :init-opened="mobile_menu_opened"
            />
            <div :class="`content-con ${withAccordion ? 'with-accordion' : ''} ${wrapContent ? 'df-wrap' : ''}`">
                <div class="con-wrapper">
                    <slot name="content"></slot>
                    <div v-if="withAccordion && items.length" class="content accordion-content">
                        <template v-if="isAccordionGroup">
                            <accordion-group>
                                <li v-for="(item, index) in items" class="accordion_group" v-bind:class="{'accordion_group-active': (currentSel === index)}">
                                    <accordion-item
                                        v-if="!item.use_slot_content"
                                        :title="item.question"
                                        :content="item.answer"
                                        :index="index"
                                        :currentItem="currentSel"
                                        @onSelectItem="onSelectItem"
                                        @agBeforeEnter="agBeforeEnter"
                                        @agOnEnter="agOnEnter"
                                    ></accordion-item>
                                    <accordion-item
                                        v-else
                                        :use-slot-content="true"
                                        :custom-container="item.custom_container"
                                        :title="item.question"
                                        :index="index"
                                        :currentItem="currentSel"
                                        @onSelectItem="onSelectItem"
                                        @agBeforeEnter="agBeforeEnter"
                                        @agOnEnter="agOnEnter"
                                    >
                                        <template slot="acc-content">
                                            <slot :name="`slot-item-${index}`"></slot>
                                        </template>
                                    </accordion-item>
                                </li>
                            </accordion-group>
                        </template>
                        <!-- // not group -->
                        <template v-else v-for="item in items">
                            <accordion-item :title="item.question" :content="item.answer"></accordion-item>
                        </template>
                        <slot name="content-after-accordion"></slot>
                    </div>
                </div>
            </div>
            <base-menu v-if="!noBottomNav && isAuthenticated" class="bottom-nav" :menu="mobile_bottom_menu"></base-menu>
        </template>
    </div>
</template>

<script>
    import MainHeader from '@theme-views/common/MainHeader'
    import MainFooter from '@theme-views/common/MainFooter'
    import MobileMenu from '@theme-views/common/MobileMenu'
    import AccordionItem from '@theme-views/common/AccordionItem'
    import AccordionGroup from '@theme-views/common/AccordionGroup'
    import BaseMenu from '@theme-views/common/BaseMenu'
    import SvgWave from '@theme-views/common/SvgIcon/Icons/Wave'
    import SvgStar from '@theme-views/common/SvgIcon/Icons/Star'
    import Default from '@views/public/layouts/Default/default'
    import {handleBackBtn} from '@/helpers'

    export default {
        mixins: [Default, AccordionGroup],
        data() {
            return {
                mobile_menu_opened: false,
                mobile_bottom_menu: [
                    { route: 'user-home', svg_icon: { name: 'svg-home', width: 27, height: 27, color: '#c5c5c5'}, name:'Home' },
                    { route: 'user-search-profiles', svg_icon: { name: 'svg-search', width: 27, height: 27, color: '#c5c5c5'}, name:'Search' },
                    { route: 'user-messages', svg_icon: { name: 'svg-chat', id: 2, width: 27, height: 27, color: '#c5c5c5'}, name:'Messages', sub_title: null },
                    { route: 'user-mobile-home', svg_icon: { name: 'svg-user', width: 27, height: 27, color: '#c5c5c5'}, name:'My Profile' },
                ],
            }
        },
        props: {
            iconLeft: {
                type: String,
                default: 'icon-pointer-left-white'
            },
            wrapContent: {
                type: Boolean,
                default: false
            },
            backFallbackRoute: {
                type: Object,
                default: () => {
                    {}
                }
            },
            noTopNav: {
                type: Boolean,
                default: false
            },
            noBottomNav: {
                type: Boolean,
                default: false
            },
            isAccordionGroup: {
              type: Boolean,
              default: false
            }
        },
        methods: {
            populateUnreadMessage(val) {
                this.addUnreadCount( this.mobile_bottom_menu, val)
            },
            addUnreadCount(menu, val) {
                let item = menu.find( (val,key) => {
                    if(val.route == 'user-messages') return val
                })
                item.sub_title = !val ? null : val.toString()
                if(item.icon_class && val) {
                    item.icon_class = 'icon icon-message-full'
                } else if(item.icon_class) {
                    item.icon_class = 'icon icon-message-grey'
                }
            },
            openMobileMenu() {
                if(this.$refs['mobile-menu']) {
                    this.$refs['mobile-menu'].openMenu()
                    this.mobile_menu_opened = this.$refs['mobile-menu'].opened
                }
            },
            handleBackClick() {
                handleBackBtn(this.$router, this.routeFrom, this.backFallbackRoute)
            },
            handleMenuClicked() {
                this.mobile_menu_opened = false
                this.$refs['mobile-menu'].closeMenu()
            }
        },
        computed: {
            unread_messages() {
                let i = this.$store.getters['auth/profile']['welcome_message'] == 1 ? 1 : 0
                let n = parseInt(this.$store.getters['auth/unreadNotifications'])
                return parseInt(this.$store.getters['auth/unreadMessages']) + i + n
            },
            routeFrom() {
                return this.$store.getters['pub/routeFrom']
            },
            hasContentSlot () {
              return !!this.$slots['content']
            },
            isAuthenticated() {
                return this.$store.getters['auth/isAuthenticated']
            },
        },
        watch: {
            unread_messages(to,from) {
                this.populateUnreadMessage(to)
            },
            '$route' (to, from) {
                if(this.$refs['mobile-menu']) {
                    this.mobile_menu_opened = false
                    this.$refs['mobile-menu'].closeMenu()
                }
            }
        },
        mounted() {
            this.populateUnreadMessage(this.unread_messages)
        },
        components: {
            MainHeader,
            MainFooter,
            MobileMenu,
            BaseMenu,
            AccordionItem,
            AccordionGroup,
            SvgWave,
            SvgStar,
        },
        created() {
            EventBus.$on('menu-clicked', this.handleMenuClicked)
        },
        beforeDestroy() {
            EventBus.$off('menu-clicked', this.handleMenuClicked)
        },
    }
</script>

<style lang="scss">
.default {
    &.main-con {
        background-color: #f8fafd;
        .content-con {
            &.df-wrap {
                padding-left: 0;
                padding-right: 0;
                > .con-wrapper {
                    border-radius: 3px;
                    box-shadow: 0 2px 4px 0 rgba(155, 155, 155, 0.2);
                    background-color: #fff;
                    margin-bottom: 100px;
                    margin-top: 12px;
                    > .content {
                        padding: 70px 32px 32px;
                    }
                }
            }
        }
        @media(max-width: 1199px) {
            background-color: #fff;
            .content-con {
                > .con-wrapper {
                    padding: 20px !important;
                }
                &.df-wrap {
                    > .con-wrapper {
                        border-radius: 3px;
                        box-shadow: none;
                        background-color: #fff;
                        margin-top: 0;
                        margin-bottom: 20px;
                        padding: 0 20px;
                    }
                }
                &.with-accordion {
                    padding: 10px 20px;
                    .con-wrapper {
                        padding: 0 !important;
                        width: 100%;
                        .accordion-item {
                            margin-bottom: 15px;
                            .acc-title-con  {
                                padding: 18px 50px;
                                text-transform: initial;
                                font-size: 15px;
                                font-weight: 500;
                                line-height: 1.5;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
